import { Entity } from '@blk/aw-bff-typescript-models';
import memoizeOne from 'memoize-one';

export const getEntityGivenAggIDTag = (entityDefs: Entity[], aggIDTag: string): Entity | undefined => {
  const mappedEntityDefs = getAggIdTagMappedEntityDefs(entityDefs);
  return mappedEntityDefs[aggIDTag];
};

export const getAggIdTagMappedEntityDefs = memoizeOne((entityDefs: Entity[]): { [aggIDTag: string]: Entity } =>
  entityDefs.reduce<{ [aggIDTag: string]: Entity }>((total, entityDef) => {
    total[entityDef.aggIDTag] = entityDef;
    return total;
  }, {})
);
